// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Pervasives = require("bs-platform/lib/js/pervasives.js");
var Plate$BwaxMobile = require("../../../plate.bs.js");
var Lang_eval$BwaxMobile = require("../../lang_eval.bs.js");
var Runtime_common$BwaxMobile = require("../runtime_common.bs.js");
var Lang_typing_base$BwaxMobile = require("../../lang_typing_base.bs.js");

var module_name = "List";

function invalid_args(name) {
  throw [
        Lang_eval$BwaxMobile.Eval_exn,
        "List." + (name + ": Invalid Arguments")
      ];
}

function pack_func(arity, f) {
  return /* tuple */[
          /* V_native_fn */Block.__(4, [
              arity,
              f,
              /* [] */0
            ]),
          Runtime_common$BwaxMobile.nt
        ];
}

function func(args) {
  if (args) {
    var match = args[0][0];
    if (typeof match === "number" || match.tag !== /* V_literal */5) {
      return invalid_args("repeat");
    } else {
      var match$1 = match[0];
      if (typeof match$1 === "number" || match$1.tag) {
        return invalid_args("repeat");
      } else {
        var match$2 = args[1];
        if (match$2 && !match$2[1]) {
          return /* tuple */[
                  /* V_list */Block.__(1, [Plate$BwaxMobile.List.fill(match$1[0], match$2[0])]),
                  Runtime_common$BwaxMobile.nt
                ];
        } else {
          return invalid_args("repeat");
        }
      }
    }
  } else {
    return invalid_args("repeat");
  }
}

function func$1(args) {
  if (args) {
    var match = args[1];
    if (match) {
      var match$1 = match[0][0];
      if (typeof match$1 === "number" || !(match$1.tag === /* V_list */1 && !match[1])) {
        return invalid_args("map");
      } else {
        var f = args[0];
        var nl = Plate$BwaxMobile.List.map((function (v) {
                return Lang_eval$BwaxMobile.apply_value(module_name, f, v, Runtime_common$BwaxMobile.nt);
              }), match$1[0]);
        return /* tuple */[
                /* V_list */Block.__(1, [nl]),
                Runtime_common$BwaxMobile.nt
              ];
      }
    } else {
      return invalid_args("map");
    }
  } else {
    return invalid_args("map");
  }
}

function func$2(args) {
  if (args) {
    var match = args[1];
    if (match) {
      var match$1 = match[0][0];
      if (typeof match$1 === "number") {
        throw [
              Lang_eval$BwaxMobile.Eval_exn,
              "List.indexedMap: Invalid Arguments"
            ];
      } else if (match$1.tag === /* V_list */1) {
        if (match[1]) {
          throw [
                Lang_eval$BwaxMobile.Eval_exn,
                "List.indexedMap: Invalid Arguments"
              ];
        }
        var f = args[0];
        var nl = Plate$BwaxMobile.List.indexed_map((function (idx, v) {
                var idx_v_000 = /* V_literal */Block.__(5, [/* Int */Block.__(0, [idx])]);
                var idx_v = /* tuple */[
                  idx_v_000,
                  Lang_typing_base$BwaxMobile.$$int
                ];
                return Lang_eval$BwaxMobile.apply_value_args(module_name, f, /* :: */[
                            idx_v,
                            /* :: */[
                              v,
                              /* [] */0
                            ]
                          ], Runtime_common$BwaxMobile.nt);
              }), match$1[0]);
        return /* tuple */[
                /* V_list */Block.__(1, [nl]),
                Runtime_common$BwaxMobile.nt
              ];
      } else {
        throw [
              Lang_eval$BwaxMobile.Eval_exn,
              "List.indexedMap: Invalid Arguments"
            ];
      }
    } else {
      throw [
            Lang_eval$BwaxMobile.Eval_exn,
            "List.indexedMap: Invalid Arguments"
          ];
    }
  } else {
    throw [
          Lang_eval$BwaxMobile.Eval_exn,
          "List.indexedMap: Invalid Arguments"
        ];
  }
}

function func$3(args) {
  if (args) {
    var match = args[1];
    if (match) {
      var match$1 = match[1];
      if (match$1) {
        var match$2 = match$1[0][0];
        if (typeof match$2 === "number") {
          throw [
                Lang_eval$BwaxMobile.Eval_exn,
                "List.foldl: Invalid Arguments"
              ];
        } else if (match$2.tag === /* V_list */1) {
          if (match$1[1]) {
            throw [
                  Lang_eval$BwaxMobile.Eval_exn,
                  "List.foldl: Invalid Arguments"
                ];
          }
          var f = args[0];
          return Plate$BwaxMobile.List.foldl((function (acc, v) {
                        return Lang_eval$BwaxMobile.apply_value_args(module_name, f, /* :: */[
                                    acc,
                                    /* :: */[
                                      v,
                                      /* [] */0
                                    ]
                                  ], Runtime_common$BwaxMobile.nt);
                      }), match[0], match$2[0]);
        } else {
          throw [
                Lang_eval$BwaxMobile.Eval_exn,
                "List.foldl: Invalid Arguments"
              ];
        }
      } else {
        throw [
              Lang_eval$BwaxMobile.Eval_exn,
              "List.foldl: Invalid Arguments"
            ];
      }
    } else {
      throw [
            Lang_eval$BwaxMobile.Eval_exn,
            "List.foldl: Invalid Arguments"
          ];
    }
  } else {
    throw [
          Lang_eval$BwaxMobile.Eval_exn,
          "List.foldl: Invalid Arguments"
        ];
  }
}

function func$4(param) {
  if (param) {
    var match = param[1];
    if (match) {
      var match$1 = match[0][0];
      if (typeof match$1 === "number") {
        throw [
              Lang_eval$BwaxMobile.Eval_exn,
              "List.foldr: Invalid Arguments"
            ];
      } else if (match$1.tag === /* V_list */1) {
        var match$2 = match[1];
        if (match$2) {
          if (match$2[1]) {
            throw [
                  Lang_eval$BwaxMobile.Eval_exn,
                  "List.foldr: Invalid Arguments"
                ];
          }
          var f = param[0];
          return Plate$BwaxMobile.List.foldr((function (v, acc) {
                        return Lang_eval$BwaxMobile.apply_value_args(module_name, f, /* :: */[
                                    v,
                                    /* :: */[
                                      acc,
                                      /* [] */0
                                    ]
                                  ], Runtime_common$BwaxMobile.nt);
                      }), match$1[0], match$2[0]);
        } else {
          throw [
                Lang_eval$BwaxMobile.Eval_exn,
                "List.foldr: Invalid Arguments"
              ];
        }
      } else {
        throw [
              Lang_eval$BwaxMobile.Eval_exn,
              "List.foldr: Invalid Arguments"
            ];
      }
    } else {
      throw [
            Lang_eval$BwaxMobile.Eval_exn,
            "List.foldr: Invalid Arguments"
          ];
    }
  } else {
    throw [
          Lang_eval$BwaxMobile.Eval_exn,
          "List.foldr: Invalid Arguments"
        ];
  }
}

function func$5(args) {
  if (args) {
    var match = args[1];
    if (match) {
      var match$1 = match[0][0];
      if (typeof match$1 === "number") {
        throw [
              Lang_eval$BwaxMobile.Eval_exn,
              "List.filter: Invalid Arguments"
            ];
      } else if (match$1.tag === /* V_list */1) {
        if (match[1]) {
          throw [
                Lang_eval$BwaxMobile.Eval_exn,
                "List.filter: Invalid Arguments"
              ];
        }
        var f = args[0];
        var nl = Plate$BwaxMobile.List.keep((function (v) {
                var match = Lang_eval$BwaxMobile.apply_value(module_name, f, v, Runtime_common$BwaxMobile.nt);
                var match$1 = match[0];
                if (typeof match$1 === "number" || match$1.tag !== /* V_literal */5) {
                  return false;
                } else {
                  var match$2 = match$1[0];
                  if (typeof match$2 === "number" || !(match$2.tag === /* Bool */4 && match$2[0])) {
                    return false;
                  } else {
                    return true;
                  }
                }
              }), match$1[0]);
        return /* tuple */[
                /* V_list */Block.__(1, [nl]),
                Runtime_common$BwaxMobile.nt
              ];
      } else {
        throw [
              Lang_eval$BwaxMobile.Eval_exn,
              "List.filter: Invalid Arguments"
            ];
      }
    } else {
      throw [
            Lang_eval$BwaxMobile.Eval_exn,
            "List.filter: Invalid Arguments"
          ];
    }
  } else {
    throw [
          Lang_eval$BwaxMobile.Eval_exn,
          "List.filter: Invalid Arguments"
        ];
  }
}

function func$6(args) {
  if (args) {
    var match = args[1];
    if (match) {
      var match$1 = match[0][0];
      if (typeof match$1 === "number") {
        throw [
              Lang_eval$BwaxMobile.Eval_exn,
              "List.filter: Invalid Arguments"
            ];
      } else if (match$1.tag === /* V_list */1) {
        if (match[1]) {
          throw [
                Lang_eval$BwaxMobile.Eval_exn,
                "List.filter: Invalid Arguments"
              ];
        }
        var f = args[0];
        var nl = Plate$BwaxMobile.List.keep_map((function (v) {
                var match = Lang_eval$BwaxMobile.apply_value(module_name, f, v, Runtime_common$BwaxMobile.nt);
                var match$1 = match[0];
                if (typeof match$1 === "number" || !(match$1.tag === /* V_tagged */6 && match$1[0] === "Just")) {
                  return ;
                } else {
                  var match$2 = match$1[1];
                  if (match$2 && !match$2[1]) {
                    return match$2[0];
                  } else {
                    return ;
                  }
                }
              }), match$1[0]);
        return /* tuple */[
                /* V_list */Block.__(1, [nl]),
                Runtime_common$BwaxMobile.nt
              ];
      } else {
        throw [
              Lang_eval$BwaxMobile.Eval_exn,
              "List.filter: Invalid Arguments"
            ];
      }
    } else {
      throw [
            Lang_eval$BwaxMobile.Eval_exn,
            "List.filter: Invalid Arguments"
          ];
    }
  } else {
    throw [
          Lang_eval$BwaxMobile.Eval_exn,
          "List.filter: Invalid Arguments"
        ];
  }
}

function func$7(args) {
  if (args) {
    var match = args[1];
    if (match) {
      var match$1 = match[0][0];
      if (typeof match$1 === "number") {
        throw [
              Lang_eval$BwaxMobile.Eval_exn,
              "List.filter: Invalid Arguments"
            ];
      } else if (match$1.tag === /* V_list */1) {
        if (match[1]) {
          throw [
                Lang_eval$BwaxMobile.Eval_exn,
                "List.filter: Invalid Arguments"
              ];
        }
        var f = args[0];
        var mv = Plate$BwaxMobile.List.find((function (v) {
                var match = Lang_eval$BwaxMobile.apply_value(module_name, f, v, Runtime_common$BwaxMobile.nt);
                var match$1 = match[0];
                if (typeof match$1 === "number" || match$1.tag !== /* V_literal */5) {
                  return false;
                } else {
                  var match$2 = match$1[0];
                  if (typeof match$2 === "number" || !(match$2.tag === /* Bool */4 && match$2[0])) {
                    return false;
                  } else {
                    return true;
                  }
                }
              }), match$1[0]);
        if (mv !== undefined) {
          return /* tuple */[
                  Runtime_common$BwaxMobile.just(mv),
                  Runtime_common$BwaxMobile.nt
                ];
        } else {
          return /* tuple */[
                  Runtime_common$BwaxMobile.nothing,
                  Runtime_common$BwaxMobile.nt
                ];
        }
      } else {
        throw [
              Lang_eval$BwaxMobile.Eval_exn,
              "List.filter: Invalid Arguments"
            ];
      }
    } else {
      throw [
            Lang_eval$BwaxMobile.Eval_exn,
            "List.filter: Invalid Arguments"
          ];
    }
  } else {
    throw [
          Lang_eval$BwaxMobile.Eval_exn,
          "List.filter: Invalid Arguments"
        ];
  }
}

function func$8(param) {
  if (param) {
    var match = param[0][0];
    if (typeof match === "number" || !(match.tag === /* V_list */1 && !param[1])) {
      return invalid_args("length");
    } else {
      var length = Plate$BwaxMobile.List.length(match[0]);
      return /* tuple */[
              /* V_literal */Block.__(5, [/* Int */Block.__(0, [length])]),
              Lang_typing_base$BwaxMobile.$$int
            ];
    }
  } else {
    return invalid_args("length");
  }
}

function func$9(param) {
  if (param) {
    var match = param[0];
    var match$1 = match[0];
    if (typeof match$1 === "number") {
      throw [
            Lang_eval$BwaxMobile.Eval_exn,
            "List.length: Invalid Arguments"
          ];
    } else if (match$1.tag === /* V_list */1) {
      if (param[1]) {
        throw [
              Lang_eval$BwaxMobile.Eval_exn,
              "List.length: Invalid Arguments"
            ];
      }
      var nl = Plate$BwaxMobile.List.rev(match$1[0]);
      return /* tuple */[
              /* V_list */Block.__(1, [nl]),
              match[1]
            ];
    } else {
      throw [
            Lang_eval$BwaxMobile.Eval_exn,
            "List.length: Invalid Arguments"
          ];
    }
  } else {
    throw [
          Lang_eval$BwaxMobile.Eval_exn,
          "List.length: Invalid Arguments"
        ];
  }
}

function func$10(args) {
  if (args) {
    var match = args[1];
    if (match) {
      var match$1 = match[0][0];
      if (typeof match$1 === "number") {
        throw [
              Lang_eval$BwaxMobile.Eval_exn,
              "List.filter: Invalid Arguments"
            ];
      } else if (match$1.tag === /* V_list */1) {
        if (match[1]) {
          throw [
                Lang_eval$BwaxMobile.Eval_exn,
                "List.filter: Invalid Arguments"
              ];
        }
        var f = args[0];
        var result = Plate$BwaxMobile.List.every((function (v) {
                var match = Lang_eval$BwaxMobile.apply_value(module_name, f, v, Runtime_common$BwaxMobile.nt);
                var match$1 = match[0];
                if (typeof match$1 === "number" || match$1.tag !== /* V_literal */5) {
                  return false;
                } else {
                  var match$2 = match$1[0];
                  if (typeof match$2 === "number" || !(match$2.tag === /* Bool */4 && match$2[0])) {
                    return false;
                  } else {
                    return true;
                  }
                }
              }), match$1[0]);
        return /* tuple */[
                /* V_literal */Block.__(5, [/* Bool */Block.__(4, [result])]),
                Lang_typing_base$BwaxMobile.bool
              ];
      } else {
        throw [
              Lang_eval$BwaxMobile.Eval_exn,
              "List.filter: Invalid Arguments"
            ];
      }
    } else {
      throw [
            Lang_eval$BwaxMobile.Eval_exn,
            "List.filter: Invalid Arguments"
          ];
    }
  } else {
    throw [
          Lang_eval$BwaxMobile.Eval_exn,
          "List.filter: Invalid Arguments"
        ];
  }
}

function func$11(args) {
  if (args) {
    var match = args[1];
    if (match) {
      var match$1 = match[0][0];
      if (typeof match$1 === "number") {
        throw [
              Lang_eval$BwaxMobile.Eval_exn,
              "List.filter: Invalid Arguments"
            ];
      } else if (match$1.tag === /* V_list */1) {
        if (match[1]) {
          throw [
                Lang_eval$BwaxMobile.Eval_exn,
                "List.filter: Invalid Arguments"
              ];
        }
        var f = args[0];
        var result = Plate$BwaxMobile.List.some((function (v) {
                var match = Lang_eval$BwaxMobile.apply_value(module_name, f, v, Runtime_common$BwaxMobile.nt);
                var match$1 = match[0];
                if (typeof match$1 === "number" || match$1.tag !== /* V_literal */5) {
                  return false;
                } else {
                  var match$2 = match$1[0];
                  if (typeof match$2 === "number" || !(match$2.tag === /* Bool */4 && match$2[0])) {
                    return false;
                  } else {
                    return true;
                  }
                }
              }), match$1[0]);
        return /* tuple */[
                /* V_literal */Block.__(5, [/* Bool */Block.__(4, [result])]),
                Lang_typing_base$BwaxMobile.bool
              ];
      } else {
        throw [
              Lang_eval$BwaxMobile.Eval_exn,
              "List.filter: Invalid Arguments"
            ];
      }
    } else {
      throw [
            Lang_eval$BwaxMobile.Eval_exn,
            "List.filter: Invalid Arguments"
          ];
    }
  } else {
    throw [
          Lang_eval$BwaxMobile.Eval_exn,
          "List.filter: Invalid Arguments"
        ];
  }
}

var external_vals_000 = /* tuple */[
  "repeat",
  /* tuple */[
    /* V_native_fn */Block.__(4, [
        2,
        func,
        /* [] */0
      ]),
    Runtime_common$BwaxMobile.nt
  ]
];

var external_vals_001 = /* :: */[
  /* tuple */[
    "range",
    pack_func(2, (function (param) {
            if (param) {
              var match = param[0][0];
              if (typeof match === "number" || match.tag !== /* V_literal */5) {
                return invalid_args("range");
              } else {
                var match$1 = match[0];
                if (typeof match$1 === "number" || match$1.tag) {
                  return invalid_args("range");
                } else {
                  var match$2 = param[1];
                  if (match$2) {
                    var match$3 = match$2[0][0];
                    if (typeof match$3 === "number" || match$3.tag !== /* V_literal */5) {
                      return invalid_args("range");
                    } else {
                      var match$4 = match$3[0];
                      if (typeof match$4 === "number" || match$4.tag || match$2[1]) {
                        return invalid_args("range");
                      } else {
                        return /* tuple */[
                                /* V_list */Block.__(1, [Plate$BwaxMobile.List.map((function (i) {
                                            return /* tuple */[
                                                    /* V_literal */Block.__(5, [/* Int */Block.__(0, [i])]),
                                                    Runtime_common$BwaxMobile.nt
                                                  ];
                                          }), Plate$BwaxMobile.List.range(match$1[0], match$4[0]))]),
                                Runtime_common$BwaxMobile.nt
                              ];
                      }
                    }
                  } else {
                    return invalid_args("range");
                  }
                }
              }
            } else {
              return invalid_args("range");
            }
          }))
  ],
  /* :: */[
    /* tuple */[
      "rangeByStep",
      pack_func(3, (function (param) {
              if (param) {
                var match = param[0][0];
                if (typeof match === "number" || match.tag !== /* V_literal */5) {
                  return invalid_args("range");
                } else {
                  var match$1 = match[0];
                  if (typeof match$1 === "number" || match$1.tag) {
                    return invalid_args("range");
                  } else {
                    var match$2 = param[1];
                    if (match$2) {
                      var match$3 = match$2[0][0];
                      if (typeof match$3 === "number" || match$3.tag !== /* V_literal */5) {
                        return invalid_args("range");
                      } else {
                        var match$4 = match$3[0];
                        if (typeof match$4 === "number" || match$4.tag) {
                          return invalid_args("range");
                        } else {
                          var match$5 = match$2[1];
                          if (match$5) {
                            var match$6 = match$5[0][0];
                            if (typeof match$6 === "number" || match$6.tag !== /* V_literal */5) {
                              return invalid_args("range");
                            } else {
                              var match$7 = match$6[0];
                              if (typeof match$7 === "number" || match$7.tag || match$5[1]) {
                                return invalid_args("range");
                              } else {
                                return /* tuple */[
                                        /* V_list */Block.__(1, [Plate$BwaxMobile.List.map((function (i) {
                                                    return /* tuple */[
                                                            /* V_literal */Block.__(5, [/* Int */Block.__(0, [i])]),
                                                            Runtime_common$BwaxMobile.nt
                                                          ];
                                                  }), Plate$BwaxMobile.List.range_by_step(match$1[0], match$4[0], match$7[0]))]),
                                        Runtime_common$BwaxMobile.nt
                                      ];
                              }
                            }
                          } else {
                            return invalid_args("range");
                          }
                        }
                      }
                    } else {
                      return invalid_args("range");
                    }
                  }
                }
              } else {
                return invalid_args("range");
              }
            }))
    ],
    /* :: */[
      /* tuple */[
        "map",
        /* tuple */[
          /* V_native_fn */Block.__(4, [
              2,
              func$1,
              /* [] */0
            ]),
          Runtime_common$BwaxMobile.nt
        ]
      ],
      /* :: */[
        /* tuple */[
          "indexedMap",
          /* tuple */[
            /* V_native_fn */Block.__(4, [
                2,
                func$2,
                /* [] */0
              ]),
            Runtime_common$BwaxMobile.nt
          ]
        ],
        /* :: */[
          /* tuple */[
            "foldl",
            /* tuple */[
              /* V_native_fn */Block.__(4, [
                  3,
                  func$3,
                  /* [] */0
                ]),
              Runtime_common$BwaxMobile.nt
            ]
          ],
          /* :: */[
            /* tuple */[
              "foldr",
              /* tuple */[
                /* V_native_fn */Block.__(4, [
                    3,
                    func$4,
                    /* [] */0
                  ]),
                Runtime_common$BwaxMobile.nt
              ]
            ],
            /* :: */[
              /* tuple */[
                "filter",
                /* tuple */[
                  /* V_native_fn */Block.__(4, [
                      2,
                      func$5,
                      /* [] */0
                    ]),
                  Runtime_common$BwaxMobile.nt
                ]
              ],
              /* :: */[
                /* tuple */[
                  "filterMap",
                  /* tuple */[
                    /* V_native_fn */Block.__(4, [
                        2,
                        func$6,
                        /* [] */0
                      ]),
                    Runtime_common$BwaxMobile.nt
                  ]
                ],
                /* :: */[
                  /* tuple */[
                    "unique",
                    pack_func(1, (function (param) {
                            if (param) {
                              var match = param[0][0];
                              if (typeof match === "number" || !(match.tag === /* V_list */1 && !param[1])) {
                                return invalid_args("unqiue");
                              } else {
                                return Runtime_common$BwaxMobile.pack_list(Plate$BwaxMobile.List.make_set((function (param) {
                                                  return Lang_eval$BwaxMobile.val_equal(param[0], param[1]);
                                                }), match[0]));
                              }
                            } else {
                              return invalid_args("unqiue");
                            }
                          }))
                  ],
                  /* :: */[
                    /* tuple */[
                      "uniqueBy",
                      pack_func(2, (function (param) {
                              if (param) {
                                var match = param[1];
                                if (match) {
                                  var match$1 = match[0][0];
                                  if (typeof match$1 === "number" || !(match$1.tag === /* V_list */1 && !match[1])) {
                                    return invalid_args("unqiueBy");
                                  } else {
                                    var predicate = param[0];
                                    return Runtime_common$BwaxMobile.pack_list(Plate$BwaxMobile.List.make_set((function (param) {
                                                      return Plate$BwaxMobile.$$Option.with_default(false, Lang_eval$BwaxMobile.as_bool(Lang_eval$BwaxMobile.apply_value_args(undefined, predicate, /* :: */[
                                                                          param[0],
                                                                          /* :: */[
                                                                            param[1],
                                                                            /* [] */0
                                                                          ]
                                                                        ], Runtime_common$BwaxMobile.nt)));
                                                    }), match$1[0]));
                                  }
                                } else {
                                  return invalid_args("unqiueBy");
                                }
                              } else {
                                return invalid_args("unqiueBy");
                              }
                            }))
                    ],
                    /* :: */[
                      /* tuple */[
                        "find",
                        /* tuple */[
                          /* V_native_fn */Block.__(4, [
                              2,
                              func$7,
                              /* [] */0
                            ]),
                          Runtime_common$BwaxMobile.nt
                        ]
                      ],
                      /* :: */[
                        /* tuple */[
                          "length",
                          /* tuple */[
                            /* V_native_fn */Block.__(4, [
                                1,
                                func$8,
                                /* [] */0
                              ]),
                            Runtime_common$BwaxMobile.nt
                          ]
                        ],
                        /* :: */[
                          /* tuple */[
                            "reverse",
                            /* tuple */[
                              /* V_native_fn */Block.__(4, [
                                  1,
                                  func$9,
                                  /* [] */0
                                ]),
                              Runtime_common$BwaxMobile.nt
                            ]
                          ],
                          /* :: */[
                            /* tuple */[
                              "all",
                              /* tuple */[
                                /* V_native_fn */Block.__(4, [
                                    2,
                                    func$10,
                                    /* [] */0
                                  ]),
                                Runtime_common$BwaxMobile.nt
                              ]
                            ],
                            /* :: */[
                              /* tuple */[
                                "map2",
                                pack_func(3, (function (param) {
                                        if (param) {
                                          var match = param[1];
                                          if (match) {
                                            var match$1 = match[0][0];
                                            if (typeof match$1 === "number" || match$1.tag !== /* V_list */1) {
                                              return invalid_args("map2");
                                            } else {
                                              var match$2 = match[1];
                                              if (match$2) {
                                                var match$3 = match$2[0][0];
                                                if (typeof match$3 === "number" || !(match$3.tag === /* V_list */1 && !match$2[1])) {
                                                  return invalid_args("map2");
                                                } else {
                                                  var fv = param[0];
                                                  var f = function (a, b) {
                                                    return Lang_eval$BwaxMobile.apply_value_args(module_name, fv, /* :: */[
                                                                a,
                                                                /* :: */[
                                                                  b,
                                                                  /* [] */0
                                                                ]
                                                              ], Runtime_common$BwaxMobile.nt);
                                                  };
                                                  return /* tuple */[
                                                          /* V_list */Block.__(1, [Plate$BwaxMobile.List.map2(f, match$1[0], match$3[0])]),
                                                          Runtime_common$BwaxMobile.nt
                                                        ];
                                                }
                                              } else {
                                                return invalid_args("map2");
                                              }
                                            }
                                          } else {
                                            return invalid_args("map2");
                                          }
                                        } else {
                                          return invalid_args("map2");
                                        }
                                      }))
                              ],
                              /* :: */[
                                /* tuple */[
                                  "any",
                                  /* tuple */[
                                    /* V_native_fn */Block.__(4, [
                                        2,
                                        func$11,
                                        /* [] */0
                                      ]),
                                    Runtime_common$BwaxMobile.nt
                                  ]
                                ],
                                /* :: */[
                                  /* tuple */[
                                    "sortWith",
                                    pack_func(2, (function (param) {
                                            if (param) {
                                              var match = param[1];
                                              if (match) {
                                                var match$1 = match[0][0];
                                                if (typeof match$1 === "number" || !(match$1.tag === /* V_list */1 && !match[1])) {
                                                  return invalid_args("sortWith");
                                                } else {
                                                  var fv = param[0];
                                                  var f = function (a, b) {
                                                    var match = Lang_eval$BwaxMobile.apply_value_args(module_name, fv, /* :: */[
                                                          a,
                                                          /* :: */[
                                                            b,
                                                            /* [] */0
                                                          ]
                                                        ], Runtime_common$BwaxMobile.nt);
                                                    var match$1 = match[0];
                                                    if (typeof match$1 === "number" || match$1.tag !== /* V_tagged */6) {
                                                      return 1;
                                                    } else {
                                                      switch (match$1[0]) {
                                                        case "EQ" :
                                                            return 0;
                                                        case "LT" :
                                                            return -1;
                                                        default:
                                                          return 1;
                                                      }
                                                    }
                                                  };
                                                  return /* tuple */[
                                                          /* V_list */Block.__(1, [Plate$BwaxMobile.List.sort(f, match$1[0])]),
                                                          Runtime_common$BwaxMobile.nt
                                                        ];
                                                }
                                              } else {
                                                return invalid_args("sortWith");
                                              }
                                            } else {
                                              return invalid_args("sortWith");
                                            }
                                          }))
                                  ],
                                  /* :: */[
                                    /* tuple */[
                                      "take",
                                      pack_func(2, (function (param) {
                                              if (param) {
                                                var match = param[0][0];
                                                if (typeof match === "number" || match.tag !== /* V_literal */5) {
                                                  return invalid_args("take");
                                                } else {
                                                  var match$1 = match[0];
                                                  if (typeof match$1 === "number" || match$1.tag) {
                                                    return invalid_args("take");
                                                  } else {
                                                    var match$2 = param[1];
                                                    if (match$2) {
                                                      var match$3 = match$2[0][0];
                                                      if (typeof match$3 === "number" || !(match$3.tag === /* V_list */1 && !match$2[1])) {
                                                        return invalid_args("take");
                                                      } else {
                                                        var l = match$3[0];
                                                        var match$4 = Plate$BwaxMobile.List.take(match$1[0], l);
                                                        var r = match$4 !== undefined ? match$4 : l;
                                                        return /* tuple */[
                                                                /* V_list */Block.__(1, [r]),
                                                                Runtime_common$BwaxMobile.nt
                                                              ];
                                                      }
                                                    } else {
                                                      return invalid_args("take");
                                                    }
                                                  }
                                                }
                                              } else {
                                                return invalid_args("take");
                                              }
                                            }))
                                    ],
                                    /* :: */[
                                      /* tuple */[
                                        "drop",
                                        pack_func(2, (function (param) {
                                                if (param) {
                                                  var match = param[0][0];
                                                  if (typeof match === "number" || match.tag !== /* V_literal */5) {
                                                    return invalid_args("drop");
                                                  } else {
                                                    var match$1 = match[0];
                                                    if (typeof match$1 === "number" || match$1.tag) {
                                                      return invalid_args("drop");
                                                    } else {
                                                      var match$2 = param[1];
                                                      if (match$2) {
                                                        var match$3 = match$2[0][0];
                                                        if (typeof match$3 === "number" || !(match$3.tag === /* V_list */1 && !match$2[1])) {
                                                          return invalid_args("drop");
                                                        } else {
                                                          var match$4 = Plate$BwaxMobile.List.drop(match$1[0], match$3[0]);
                                                          var r = match$4 !== undefined ? match$4 : /* [] */0;
                                                          return /* tuple */[
                                                                  /* V_list */Block.__(1, [r]),
                                                                  Runtime_common$BwaxMobile.nt
                                                                ];
                                                        }
                                                      } else {
                                                        return invalid_args("drop");
                                                      }
                                                    }
                                                  }
                                                } else {
                                                  return invalid_args("drop");
                                                }
                                              }))
                                      ],
                                      /* :: */[
                                        /* tuple */[
                                          "partition",
                                          pack_func(2, (function (param) {
                                                  if (param) {
                                                    var match = param[1];
                                                    if (match) {
                                                      var match$1 = match[0][0];
                                                      if (typeof match$1 === "number" || !(match$1.tag === /* V_list */1 && !match[1])) {
                                                        return invalid_args("partition");
                                                      } else {
                                                        var fv = param[0];
                                                        var f = function (e) {
                                                          var match = Lang_eval$BwaxMobile.apply_value(module_name, fv, e, Runtime_common$BwaxMobile.nt);
                                                          var match$1 = match[0];
                                                          if (typeof match$1 === "number" || match$1.tag !== /* V_literal */5) {
                                                            return true;
                                                          } else {
                                                            var match$2 = match$1[0];
                                                            if (typeof match$2 === "number" || !(match$2.tag === /* Bool */4 && !match$2[0])) {
                                                              return true;
                                                            } else {
                                                              return false;
                                                            }
                                                          }
                                                        };
                                                        var match$2 = Curry._2(Plate$BwaxMobile.List.partition, f, match$1[0]);
                                                        return /* tuple */[
                                                                /* V_tuple */Block.__(0, [/* :: */[
                                                                      /* tuple */[
                                                                        /* V_list */Block.__(1, [match$2[0]]),
                                                                        Runtime_common$BwaxMobile.nt
                                                                      ],
                                                                      /* :: */[
                                                                        /* tuple */[
                                                                          /* V_list */Block.__(1, [match$2[1]]),
                                                                          Runtime_common$BwaxMobile.nt
                                                                        ],
                                                                        /* [] */0
                                                                      ]
                                                                    ]]),
                                                                Runtime_common$BwaxMobile.nt
                                                              ];
                                                      }
                                                    } else {
                                                      return invalid_args("partition");
                                                    }
                                                  } else {
                                                    return invalid_args("partition");
                                                  }
                                                }))
                                        ],
                                        /* :: */[
                                          /* tuple */[
                                            "zip",
                                            pack_func(1, (function (param) {
                                                    if (param) {
                                                      var match = param[0][0];
                                                      if (typeof match === "number" || match.tag) {
                                                        return invalid_args("zip");
                                                      } else {
                                                        var match$1 = match[0];
                                                        if (match$1) {
                                                          var match$2 = match$1[0][0];
                                                          if (typeof match$2 === "number" || match$2.tag !== /* V_list */1) {
                                                            return invalid_args("zip");
                                                          } else {
                                                            var match$3 = match$1[1];
                                                            if (match$3) {
                                                              var match$4 = match$3[0][0];
                                                              if (typeof match$4 === "number" || !(match$4.tag === /* V_list */1 && !(match$3[1] || param[1]))) {
                                                                return invalid_args("zip");
                                                              } else {
                                                                var lr = Plate$BwaxMobile.List.map((function (param) {
                                                                        return /* tuple */[
                                                                                /* V_tuple */Block.__(0, [/* :: */[
                                                                                      param[0],
                                                                                      /* :: */[
                                                                                        param[1],
                                                                                        /* [] */0
                                                                                      ]
                                                                                    ]]),
                                                                                Runtime_common$BwaxMobile.nt
                                                                              ];
                                                                      }), Plate$BwaxMobile.List.combine(match$2[0], match$4[0]));
                                                                return /* tuple */[
                                                                        /* V_list */Block.__(1, [lr]),
                                                                        Runtime_common$BwaxMobile.nt
                                                                      ];
                                                              }
                                                            } else {
                                                              return invalid_args("zip");
                                                            }
                                                          }
                                                        } else {
                                                          return invalid_args("zip");
                                                        }
                                                      }
                                                    } else {
                                                      return invalid_args("zip");
                                                    }
                                                  }))
                                          ],
                                          /* :: */[
                                            /* tuple */[
                                              "unzip",
                                              pack_func(1, (function (param) {
                                                      if (param) {
                                                        var match = param[0][0];
                                                        if (typeof match === "number" || !(match.tag === /* V_list */1 && !param[1])) {
                                                          return invalid_args("unzip");
                                                        } else {
                                                          var lt = Plate$BwaxMobile.List.map((function (param) {
                                                                  var match = param[0];
                                                                  if (typeof match === "number" || match.tag) {
                                                                    return Pervasives.invalid_arg("unzip");
                                                                  } else {
                                                                    var match$1 = match[0];
                                                                    if (match$1) {
                                                                      var match$2 = match$1[1];
                                                                      if (match$2 && !match$2[1]) {
                                                                        return /* tuple */[
                                                                                match$1[0],
                                                                                match$2[0]
                                                                              ];
                                                                      } else {
                                                                        return Pervasives.invalid_arg("unzip");
                                                                      }
                                                                    } else {
                                                                      return Pervasives.invalid_arg("unzip");
                                                                    }
                                                                  }
                                                                }), match[0]);
                                                          var match$1 = Plate$BwaxMobile.List.unzip(lt);
                                                          return /* tuple */[
                                                                  /* V_tuple */Block.__(0, [/* :: */[
                                                                        /* tuple */[
                                                                          /* V_list */Block.__(1, [match$1[0]]),
                                                                          Runtime_common$BwaxMobile.nt
                                                                        ],
                                                                        /* :: */[
                                                                          /* tuple */[
                                                                            /* V_list */Block.__(1, [match$1[1]]),
                                                                            Runtime_common$BwaxMobile.nt
                                                                          ],
                                                                          /* [] */0
                                                                        ]
                                                                      ]]),
                                                                  Runtime_common$BwaxMobile.nt
                                                                ];
                                                        }
                                                      } else {
                                                        return invalid_args("unzip");
                                                      }
                                                    }))
                                            ],
                                            /* :: */[
                                              /* tuple */[
                                                "splitBy",
                                                pack_func(2, (function (param) {
                                                        if (param) {
                                                          var match = param[0][0];
                                                          if (typeof match === "number" || match.tag !== /* V_literal */5) {
                                                            return invalid_args("splitBy");
                                                          } else {
                                                            var match$1 = match[0];
                                                            if (typeof match$1 === "number" || match$1.tag) {
                                                              return invalid_args("splitBy");
                                                            } else {
                                                              var match$2 = param[1];
                                                              if (match$2) {
                                                                var match$3 = match$2[0][0];
                                                                if (typeof match$3 === "number" || !(match$3.tag === /* V_list */1 && !match$2[1])) {
                                                                  return invalid_args("splitBy");
                                                                } else {
                                                                  var lr = Plate$BwaxMobile.List.map((function (il) {
                                                                          return /* tuple */[
                                                                                  /* V_list */Block.__(1, [il]),
                                                                                  Runtime_common$BwaxMobile.nt
                                                                                ];
                                                                        }), Plate$BwaxMobile.List.batches(match$1[0], match$3[0]));
                                                                  return /* tuple */[
                                                                          /* V_list */Block.__(1, [lr]),
                                                                          Runtime_common$BwaxMobile.nt
                                                                        ];
                                                                }
                                                              } else {
                                                                return invalid_args("splitBy");
                                                              }
                                                            }
                                                          }
                                                        } else {
                                                          return invalid_args("splitBy");
                                                        }
                                                      }))
                                              ],
                                              /* [] */0
                                            ]
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ]
];

var external_vals = /* :: */[
  external_vals_000,
  external_vals_001
];

var externals_000 = module_name;

var externals = /* tuple */[
  externals_000,
  external_vals
];

var src = "\nmodule List;\n\n-- Create a list with n copies of a value\nrepeat: Int -> a -> List a = external;\n\n-- Create a list of numbers, every element increasing by one\n-- You give the lowest and highest number that should be in the list.\n-- It should return \nrange: Int -> Int -> List Int = external;\n\n-- starting number, ending number, step\nrangeByStep: Int -> Int -> Int -> List Int = external;\n\n-- Apply a function to every element of a list.\nmap f l: (a -> b) -> List a -> List b = external;\n\n-- Same as map but the function is also applied to the index of each element (starting at zero).\nindexedMap: (Int -> a -> b) -> List a -> List b = external;\n\n-- Reduce a list from the left.\nfoldl f acc l: (b -> a -> b) -> b -> List a -> b = external;\n\n-- Reduce a list from the right.\nfoldr f l init: (a -> b -> b) -> List a -> b -> b = external;\n\n-- Keep elements that satisfy the test.\nfilter: (a -> Bool) -> List a -> List a = external;\n\n-- Filter out certain values. \n-- For example, maybe you have a bunch of strings from an untrusted source and \n-- you want to turn them into numbers:\nfilterMap f l: (a -> Maybe b) -> List a -> List b = external;\n\n-- Remove all Nothing values.\nclean l: List (Maybe a) -> List a = \n  l |> filterMap (\\v -> v)\n;\n\n\n-- Monads functions:\n-- Same as concat map, but it is a more general name.\nflatMap f l: (a -> List b) -> List a -> List b = \n  concat (map f l);\n  \nreturn v: a -> List a = [v];\nfail: List a = [];\n\nguard test: Bool -> List a  = \n  if test then [()] else [];\n;\n---\n\n\n-- return the unique ones according to the default equality\nunique: List a -> List a = external;\n\nuniqueBy: (a -> a -> Bool) -> List a -> List a = external;\n\n\n-- Find the first element that satisfies the test.\nfind: (a -> Bool) -> List a -> Maybe a = external;\n\n-- Given an associated list, find the element (snd value) by the key (fst value)\nassoc n al =\n  al |> find(\\(k, _) -> k == n) |> Maybe.map (\\(_, v) -> v)\n;\n\n-- Determine the length of a list.\nlength: List a -> Int = external;\n\n-- Reverse a list.\nreverse: List a -> List a = external;\n\n-- Determine if all elements satisfy some test.\nall: (a -> Bool) -> List a -> Bool = external;\n\n-- Determine if any elements satisfy some test.\nany: (a -> Bool) -> List a -> Bool = external;\n\n\n-- Combine two lists, combining them with the given function. \n-- If one list is longer, the extra elements are dropped.\nmap2 : (a -> b -> result) -> List a -> List b -> List result = external;\n\n\n-- TODO 类型检查的 occurs 有问题，如下 maximum 和 minimum 的实现会报： \n--    v `comparable80` occurs in t `Maybe comparable80`\n-- Find the maximum element in a non-empty list.\n-- maximum l: List comparable -> Maybe comparable = \n--  foldl\n--    (\\acc x -> \n--        case acc of \n--        | Nothing -> x\n--        | Just a -> if a < x then x else a)\n--    Nothing\n--    l;\n\n-- Find the minimum element in a non-empty list.\n-- minimum l: List comparable -> Maybe comparable =\n--  foldl\n--    (\\acc x -> \n--        case acc of \n--        | Nothing -> x\n--        | Just a -> if a < x then a else x)\n--    Nothing\n--    l;\n\n-- Figure out whether a list contains a value.\nmember v l: a -> List a -> Bool = \n  any (\\x -> x == v) l;\n\n\nhas v l = member v l;\ncontains v l = member v l;\n\n-- Get the sum of the list elements.\nsum l = foldl (\\acc x -> acc + x) 0 l;\n\n-- Get the product of the list elements.\nproduct l = foldl (\\acc x -> acc * x) 1 l;\n\n-- Concatenate a bunch of lists into a single list:\nconcat l: List (List a) -> List a = \n  foldr (\\x acc -> x ++ acc) l [];\n\n-- Map a given function onto a list and flatten the resulting lists.\nconcatMap f l: (a -> List b) -> List a -> List b = \n  concat (map f l);\n\n\n\n\n-- Sort values with a custom comparison function.\nsortWith : (a -> a -> Order) -> List a -> List a = external;\n\n-- Sort values from lowest to highest\nsort l: List comparable -> List comparable =\n  sortWith compare l;\n\n-- Sort values by a derived property.\nsortBy f l: (a -> comparable) -> List a -> List a = \n  sortWith (\\x y -> compare (f x) (f y)) l;\n\n\n-- Determine if a list is empty.\nisEmpty l: List a -> Bool =\n  l == [];\n\n-- Extract the first element of a list.\nhead l: List a -> Maybe a =\n  case l of \n  | hd :: _ -> Just hd\n  | [] -> Nothing;\n\n-- Extract the rest of the list.\ntail l : List a -> Maybe (List a) =\n  case l of \n  | _ :: tl -> Just tl\n  | [] -> Nothing;\n\n-- Take the first n members of a list.\ntake : Int -> List a -> List a = external;\n\n-- Drop the first n members of a list.\ndrop : Int -> List a -> List a = external;\n\n\n-- Partition a list based on some test. \n-- The first list contains all values that satisfy the test, \n-- and the second list contains all the value that do not.\npartition : (a -> Bool) -> List a -> ( List a, List a ) = external;\n\n\n-- Compose a tuple of lists into a list of tuples\nzip: (List a, List b) -> List (a, b) = external;\n\n-- Decompose a list of tuples into a tuple of lists.\nunzip : List ( a, b ) -> ( List a, List b ) = external;\n\n\n-- Split a list into multiples lists, \n--- each of which has at most n elements.\nsplitBy: Int -> List a -> List (List a) = external;\n\n-- TODO 有空想好了怎么 split 再实现\n-- Split a list into preferably n lists (maybe less), \n-- each of which as least one element, and most of which have equal size.\n-- splitInto n l : Int -> List a -> List (List a) = \n--  let \n--    len = length l\n--  , size = if len > n \n--  in \n--    splitBy size l;\n";

exports.src = src;
exports.module_name = module_name;
exports.invalid_args = invalid_args;
exports.pack_func = pack_func;
exports.external_vals = external_vals;
exports.externals = externals;
/* external_vals Not a pure module */
